import { createAction } from '@reduxjs/toolkit';
import { buildIndexedViews } from './buildIndexedViews';
export const quickFetchHelpDeskViewsPending = createAction('fetchCustomViews/quickFetchHelpDeskViewsPending', inboxId => {
  return {
    payload: {
      inboxId
    }
  };
});
export const quickFetchHelpDeskViewsSucceeded = createAction('fetchCustomViews/quickFetchHelpDeskViewsSucceeded', (response, inboxId) => {
  const views = buildIndexedViews({
    customViews: response.hydratedCustomViews
  });
  return {
    payload: {
      latestPlaybackTimestamp: response.latestPlaybackTimestamp,
      views,
      requestArgs: {
        inboxId
      }
    }
  };
});
export const quickFetchHelpDeskViewsFailed = createAction('fetchCustomViews/quickFetchHelpDeskViewsFailed', inboxId => {
  return {
    payload: {
      requestArgs: inboxId ? {
        inboxId
      } : undefined
    }
  };
});